import React from 'react';
import PropTypes from 'prop-types';
import ImageUpload from './ImageUpload';
import Document from './Document';

const File = ({ metadata, field, setValue }) => {
  return metadata.uploadConfig.acceptedFileTypes.some(type =>
    ['.jpeg', '.png', '.jpg'].includes(type)
  ) ? (
    <ImageUpload metadata={metadata} field={field} setValue={setValue} />
  ) : (
    <Document metadata={metadata} field={field} setValue={setValue} />
  );
};
File.propTypes = {
  metadata: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired
};
export default File;
